var a="undefined";var r="default";var e="true";var v="false";var d="*";export{r as DEFAULT,v as FALSE,e as TRUE,a as UNDEFINED,d as WILDCARD};
